import React from 'react';

import { JobStatus } from '@ariksa/reporting';
import { ScheduleInterval } from '@ariksa/reporting';
import { Box } from '@chakra-ui/react';
import dayjs from 'dayjs';
import capitalize from 'lodash/capitalize';

import { renderStatusTag, StackedCell, Tag } from 'components/DataDisplay';
import { toTitleCase } from 'utils/string';

export const renderSchedule = ({ row }) => {
  const scheduled_time = row?.scheduled_time?.split(':');

  let time = dayjs
    .utc()
    .hour(scheduled_time[0])
    .minute(scheduled_time[1])
    .local()
    .format('hh:mm A');

  const renderMonth = () => {
    // 11th-13th take "th" (not "st"/"nd"/"rd"); the plain `% 10` check
    // rendered "11st", "12nd" and "13rd".
    const day = row?.day_of_month % 100;
    if (day >= 11 && day <= 13) return 'th';
    switch (row?.day_of_month % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  switch (row?.frequency) {
    case ScheduleInterval.Weekly:
      time = toTitleCase(row?.day_of_week);
      break;
    case ScheduleInterval.Monthly:
      time = row?.day_of_month + renderMonth() + ' of Month';
      break;
    case ScheduleInterval.NWeekly:
      time =
        row?.day_of_month + renderMonth() + ' ' + toTitleCase(row?.day_of_week);
      break;
    case ScheduleInterval.Yearly:
      time = row?.day_of_month + renderMonth() + ' ' + capitalize(row?.month);
      break;
  }
  return (
    <StackedCell
      upper={
        dayjs(row.end_date).isBefore(row?.start_date, 'minutes') ||
        dayjs().isAfter(row?.end_date, 'minutes')
          ? 'Expired'
          : row?.frequency === ScheduleInterval.NWeekly
          ? ScheduleInterval.Monthly
          : row?.frequency
      }
      lower={time}
    />
  );
};

export const renderReportStatus = ({ row }) => {
  return renderStatusTag(row?.report_status);
};
